import { render, staticRenderFns } from "./storesWithdrawals.vue?vue&type=template&id=0efa7844"
import script from "./storesWithdrawals.vue?vue&type=script&lang=js"
export * from "./storesWithdrawals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports